import React from 'react';
import { Outlet } from 'react-router-dom';
import MTopBar from '../ui/atoms/MTopBar';
import MDone from '../ui/atoms/MDone';
import { useBackNavigation } from '@/hooks/useBackNavigation';
import MFooterNavigation from '../ui/atoms/MFooterNavigation';


/**
 * LandingPageLayout: Used for 3rd Level Screens all initial Listing/Landing Screen.
 * Renders a top bar, main content and Bottom Done Button.
 * 
 * @param {Object} props - Component props
 * @param {string} [props.exitPath] - Path to navigate when exit is clicked
 * @param {boolean} [props.hideExit] - Whether to hide the exit button
 * @param {boolean} [props.showDoneButton] - Whether to show the done button
 * @param {Function} [props.onDone] - Custom function to call when done is clicked (optional, falls back to back navigation)
 * @param {boolean} [props.doneButtonDisabled] - Whether the done button is disabled
 */
interface LandingPageLayoutProps extends React.PropsWithChildren<{}> {
  exitPath?: string;
  hideExit?: boolean;
  showDoneButton?: boolean;
  onDone?: () => void;
  doneButtonDisabled?: boolean;
  showGradient?: boolean;
  hideBack?: boolean;
  showFooter?: boolean;
  onBack?: () => void;
}

const LandingPageLayout: React.FC<LandingPageLayoutProps> = ({
  children,
  exitPath = '/',
  hideExit = false,
  onDone,
  showDoneButton = false,
  showGradient = false,
  doneButtonDisabled = false,
  hideBack = false,
  showFooter = false,
  onBack,
}) => {
  const { handleBack } = useBackNavigation({ onBack });

  const handleDoneClick = () => {
    if (onDone) {
      onDone();
    } else {
      handleBack();
    }
  };

  return (
    <div className="flex flex-col h-screen" style={{background: showGradient ? 'linear-gradient(181deg, #FBF6FF 77.96%)' : '#fff'}}>
      <MTopBar hideProfilePicker hideBack={hideBack} onBack={onBack} />
      {/* <MExit className="absolute top-[6px] right-[16px] mt-[64px] z-10" path={exitPath} hideExit={hideExit} /> */}

      <div className="flex-1 flex flex-col min-h-0 overflow-hidden bg-white">
        <div className="flex-1 overflow-y-auto">
          <div className="min-h-full">
            {children ? children : <Outlet />}
          </div>
        </div>
        
        {/* Gradient fade effect at the bottom */}
        <div className="sticky bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-transparent pointer-events-none" />
      </div>
      {showDoneButton && (
          <MDone
            onClick={handleDoneClick}
            disabled={doneButtonDisabled}
            className="w-full"
          />
      )}
      {showFooter && (
        <MFooterNavigation />
      )}
    </div>
  );
};

export default LandingPageLayout;